<template>
  <div class="vendors_index">
    <div class="search-line">
        <div class="left">
          <el-input v-model="queryParams.name" class="search-input" clearable :placeholder="`供应商`"></el-input>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="getSearch">查询</el-button>
          <el-button type="primary" icon="el-icon-plus" size="mini" @click.prevent="createvendors">新建</el-button>
        </div>
        <table-header-editor :headers="tableHeaders"  class="header-editor" />
    </div>
    <el-tabs v-model="queryParams.type"  @tab-click="getList()">
      <el-tab-pane
        v-for="(item) in sorts"
        :key="item.value"
        :label="item.name"
        :name="item.value + ''"
      >
      </el-tab-pane>
    </el-tabs>
    <div class="vendors_center">
      <div class="list-content">
        <el-table
          :data="list"
          stripe 
          v-loading="loading"
          :header-cell-class-name="'table-header-cell'"
          @sort-change="sortChange"
          border
        >
          <el-table-column
            v-for="(item) in tableHeaders"
            :key="item.id"
            :type="item.type"
            :label="item.label"
            :prop="item.prop"
            :sortable="!!item.sortKey ? 'custom': false"
            :sort-by="item.sortKey"
            :width="item.width">
              <template slot-scope="scope">
                <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
                <span v-else>{{scope.row[item.prop]}}</span>
                <el-tooltip v-if="item.img" effect="dark" :content="`点击查看大图`" placement="top-start">
                  <el-image 
                    style="width: 30px; height: 30px"
                    :src="url" 
                    :preview-src-list="srcList">
                  </el-image>
                </el-tooltip>
                <el-tooltip v-if="item.handle" effect="dark" :content="`编辑`" placement="top-start">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="editvendors(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
                </el-tooltip>
                <el-tooltip v-if="item.handle" effect="dark" :content="`删除`" placement="top-start">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="vendorsDelete(scope.row.id)"><i class="el-icon-delete"></i></el-button>
                </el-tooltip>
              </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
import TableHeaderEditor from '@/components/common/TableHeaderEditor.vue'
import { vendorsList, vendorsDelete } from '@/api.js' 
import { pageSize } from '@/utils/Config.js'
export default {
    name:'instrumentIndex',
    components: {
      Pagination,
      TableHeaderEditor
    },
    data() {
        return {
            // 查询参数
            queryParams: {
              pageIndex: 1,
              pageSize,
              _total: 0,
              name: '',
              type: '0',
            },
            tableHeaders: [],
            typeOptions:[],
            typeOptionsTwo:[],
            //器械列表
            list:[],
            loading:true,
            total: 0,
            sorts:[],
        }
    },
    created() {
      this.searchTypeOption();
      this.getList();
    },
    methods: {
      /** 查询供应商列表 */
      getSearch(){
        this.queryParams.pageIndex = 1;
        this.getList();
      },
      getList() {
        // 获取列表数据
        console.log(this.queryParams.typeName)
        const url = vendorsList
        const {
          pageIndex,
          pageSize,
          name,
          type,
          orderBy,
          order,
        } = this.queryParams
        const queryParams = {
          page: pageIndex,
          per_page: pageSize,
          name,
          type,
          order_column: orderBy,
          order,
        }
        this.$request('get', url, queryParams)
        .then((res) => {
          if (res) {
            const prev = [
              {
                width: 60,
                label: '#',
                prop: '',
                type: 'index',
                checked: true
              }
            ]
            const last = [
              {
                width: 'auto',
                label: `操作`,
                prop: '',
                checked: true,
                handle: true
              }
            ]
            this.tableHeaders = this.tableHeaders.length > 0 ? this.tableHeaders : this.$utils.generateColumns(res.columns, prev, last)
            this.list = res.data
            this.queryParams._total = res.total
          }
        })
        this.loading = false;
      },
      sortChange(item) {
        // 排序方法
        const { column, order } = item
        const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
        const orderBy = order ? column.sortBy : undefined

        this.queryParams.order = orderString
        this.queryParams.orderBy = orderBy
        this.getList()
      },
      //删除供应商
      vendorsDelete(id){
        this.$confirm(`确认删除吗？`,{
          type: 'warning'
        })
        .then(() => {
          const url = vendorsDelete.replace('{id}', id)
          this.$request('post', url, {})
          .then((res) => {
            if (res) {
              this.$message.success(`删除成功`)
              this.getList()
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
      },
      //查询供应商类型
      searchTypeOption(){
        return this.$utils.getDict(305).then((typeOptions) => {
          if(typeOptions){
            this.sorts = typeOptions[305];
            this.sorts.unshift({
              value: '0',
              name: `全部`
            })
            this.queryParams.type = this.sorts[0].value
          }
        })
      },
      // 新建供应商
      createvendors(){
        this.$router.push(`/basic/vendors/edit/0`)
      },
      //编辑供应商
      editvendors(row) {
        this.$router.push(`/basic/vendors/edit/${row.id || 0}`)
      },
    }
}
</script>

<style lang="scss" scoped>
.vendors_index{
  .vendors_center{
    background: white;
    padding: 10px;
    border-radius: 10px;
  }
  .imageSize{
    font-size: 22px;
  }
  .header-editor {
    position: relative;
    right: 10px;
    z-index: 5;
    top: 35px;
  }
}
</style>